import _set from 'lodash/fp/set';

import { PRESET_OPTIONS, getDefaultColumns } from 'consts/dashboard';
import type { Page } from 'consts/pages';

import type { StoreState } from '../index';
import { DASHBOARDS, INITIAL_CONFIG, type ColumnsConfig, type DashboardConfig, type Widget } from './config';

export const mapColumnsConfig = (config: Partial<DashboardConfig> | null | undefined): ColumnsConfig => {
  const dashboardConfigs = DASHBOARDS.reduce<Record<string, string[]>>((xs, dash) => {
    const raw = config?.columnsConfig?.[dash];
    const existing = Array.isArray(raw) ? raw : undefined;
    return {
      ...xs,
      [dash]: existing && existing.length > 0 ? existing : getDefaultColumns({ page: dash }),
    };
  }, {});

  const log = Object.keys(INITIAL_CONFIG.columnsConfig.log).reduce<Record<string, string[]>>((xs, logType) => {
    const existing = config?.columnsConfig?.log?.[logType];
    return {
      ...xs,
      [logType]: existing?.length ? existing : getDefaultColumns({ log: logType } as { page: string; log?: string }),
    };
  }, {});

  return { ...dashboardConfigs, log };
};

export const addMissingDefaultPresets = (config: DashboardConfig): DashboardConfig => {
  let newConfig = config;

  for (const page in PRESET_OPTIONS) {
    for (const preset of PRESET_OPTIONS[page as Page] ?? []) {
      if (!newConfig.presets[page][preset.value]) {
        newConfig = _set(`presets.${page}.${preset.value}`, preset.defaultWidgets, newConfig);
      }
    }
  }

  return newConfig;
};

export const setPagePresetConfig = (
  state: StoreState,
  page: string,
  preset: string,
  pageConfig: Widget[],
): StoreState => {
  return _set(`dashboardConfiguration.config.presets.${page}.${preset}`, pageConfig, state);
};

export const setColumnsConfig = (
  state: StoreState,
  page: string,
  log: string | undefined,
  columns: string[],
): StoreState => {
  if (log) {
    return _set(`dashboardConfiguration.config.columnsConfig.log.${log}`, columns, state);
  }

  return _set(`dashboardConfiguration.config.columnsConfig.${page}`, columns, state);
};
